// Simple content for demo
module.exports = {
  label: 'Text button',
  variant: 'ghost',
};
